import { Pipe, PipeTransform } from '@angular/core';
import { FuseUtils } from '../fuseUtils';

@Pipe({name: 'filter'})
export class FilterPipe implements PipeTransform
{
    transform(mainArr: any[], searchText: string, property: string): any
    {
        return FuseUtils.filterArrayByString(mainArr, searchText);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/core/pipes/filter.pipe.ts